import styled from 'styled-components';
import { PropertyCardDataAreaMixin } from '../../mixins/components/PropertyCardDataAreaMixin';
import { Paragraph } from '../Paragraph/Paragraph';
export var StyledPropertyCardDataArea = /*#__PURE__*/styled(Paragraph).withConfig({
  displayName: "StyledPropertyCardDataArea",
  componentId: "c11n-8-111-1__sc-10i1r6-0"
})(["", ""], PropertyCardDataAreaMixin);